var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getQueryParams } from '../publicUtils';
import { DEFAULT_LANGUAGE } from './Translations';
export var getMultilingualLanguageFromQuery = function () {
    var queryParams = getQueryParams();
    var multilingualLanguage = queryParams === null || queryParams === void 0 ? void 0 : queryParams.get('lang');
    return multilingualLanguage || undefined;
};
export var getUserLanguageFromWixSDK = function (Wix) {
    return (Wix === null || Wix === void 0 ? void 0 : Wix.Utils.getLocale()) || DEFAULT_LANGUAGE;
};
export var getSiteLanguageFromSDK = function (editorSDK, isMultilingualEnabled) { return __awaiter(void 0, void 0, void 0, function () {
    var language, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!isMultilingualEnabled) return [3 /*break*/, 4];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, editorSDK.language.current.get('')];
            case 2:
                language = _a.sent();
                return [2 /*return*/, language];
            case 3:
                e_1 = _a.sent();
                return [2 /*return*/, getMultilingualLanguageFromQuery()];
            case 4: return [2 /*return*/, editorSDK.info.getRegionalLanguage('')];
        }
    });
}); };
export var getSiteLanguagesFromSDK = function (editorSDK, fallback) {
    if (fallback === void 0) { fallback = []; }
    return __awaiter(void 0, void 0, void 0, function () {
        var originalLanguage, primaryLanguage, secondaryLanguages, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, editorSDK.language.original.get('')];
                case 1:
                    originalLanguage = _a.sent();
                    primaryLanguage = {
                        isPrimaryLanguage: true,
                        languageCode: originalLanguage.languageCode,
                        locale: originalLanguage.locale,
                    };
                    return [4 /*yield*/, editorSDK.language.getTranslationLanguages('')];
                case 2:
                    secondaryLanguages = (_a.sent()).map(function (langauge) {
                        return {
                            isPrimaryLanguage: false,
                            languageCode: langauge.languageCode,
                            locale: langauge.locale,
                        };
                    });
                    return [2 /*return*/, __spreadArray([primaryLanguage], secondaryLanguages, true)];
                case 3:
                    e_2 = _a.sent();
                    return [2 /*return*/, fallback];
                case 4: return [2 /*return*/];
            }
        });
    });
};
export var extractLanguageCode = function (language) {
    // even though types are saying that language is always defined, it could be undefined
    return language && language.split('-')[0];
};
//# sourceMappingURL=utils.js.map